export default __webpack_public_path__ + "static/media/eua-flag.823755fe.svg";